import { langPath } from '../utils/siteNav';

// Language-neutral facts shared by meta tags, JSON-LD and the on-page SEO copy. Keep NAP data identical everywhere (Google Business Profile, site, schema).
export const SITE = 'https://umapremium.me';

export const HOTEL = {
  name: 'Hotel Uma Premium',
  alternateNames: ['Hotel Uma Premium Ulcinj', 'Uma Premium Hotel Ulcinj', 'Hotel Uma Premium Ulqin', 'Uma Premium Montenegro'],
  phone: '+382 68 188 816',
  email: 'umapremiumul@gmail.com',
  street: 'Ulcinjsko polje bb',
  city: 'Ulcinj',
  postalCode: '85360',
  countryCode: 'ME',
  lat: 41.9184254,
  lng: 19.2423905,
  checkin: '14:00',
  checkout: '10:00',
  spokenLanguages: ['English', 'Montenegrin', 'Albanian', 'German', 'Russian'],
};
// Legal entity shown on the Imprint / Privacy / Terms pages — fill in PIB, registration number and responsible person when available.
export const LEGAL_ENTITY = {
  company: 'Uma Hospitality d.o.o. (Hotel Uma Premium)',
  address: 'Ulcinjsko polje bb, 85360 Ulcinj, Montenegro',
  phone: HOTEL.phone,
  email: HOTEL.email,
  pib: '',
  reg: '',
  director: 'Ekrem Ismailaga',
  updated: '2026-06-01',
};

export const GOOGLE_MAPS_URL = 'https://maps.google.com/?cid=17442063066248830827';
export const GOOGLE_TRAVEL_URL = 'https://www.google.com/travel/hotels/entity/CgsI677j7aX-qYfyARAB';
HOTEL.mapUrl = GOOGLE_MAPS_URL;

export const SOCIAL = [
  'https://www.facebook.com/umapremium/',
  'https://www.instagram.com/hotelumapremium/',
  'https://www.tiktok.com/@umapremium',
  GOOGLE_MAPS_URL,
  GOOGLE_TRAVEL_URL,
];

export const AMENITIES = [
  'Rooftop swimming pool', 'Outdoor swimming pool', "Children's pool", 'Free WiFi', 'Free private parking',
  'Restaurant', 'Bar', 'Halal-friendly breakfast buffet', '24-hour front desk', 'Elevator', 'Air conditioning',
  'Sun terrace', 'Family rooms', 'Balcony in every room', 'Airport shuttle (paid)', 'Luggage storage', 'Room service',
];

// Beds24 room type id → translations.roomTypes key (names + descriptions exist in all 8 languages).
export const ROOM_KEYS = {
  679439: 'economyDouble', 679454: 'standardDouble', 679455: 'superiorDouble',
  679456: 'tripleBalcony', 679458: 'oneBedApartment', 679459: 'royalApartment',
};
export const ROOM_BEDS = { 679439: 'Double bed', 679454: 'Double bed', 679455: 'Double bed' };

export const LANG_TAGS = { en: 'en', me: 'sr', sq: 'sq', de: 'de', pl: 'pl', ru: 'ru', hu: 'hu', ro: 'ro' };
export const OG_LOCALES = { en: 'en_US', de: 'de_DE', sq: 'sq_AL', me: 'sr_ME', pl: 'pl_PL', ru: 'ru_RU', hu: 'hu_HU', ro: 'ro_RO' };

// Canonical URL of a page in a language: EN home "/", other homes "/de/", pages "/de/rooms" (matches sitemap.xml).
export const absUrl = (lang, page = '') => `${SITE}${langPath(lang, page)}${page ? '' : (lang === 'en' ? '' : '/')}`;
